<template>
	<div class="indexView">
		<el-container>
			<el-main>
				<div v-if="url">
					<video id="playVideo" width="100%" height="100%" controls muted autoplay
						controlslist="nodownload noremoteplayback">
						<source :src="url" type="video/mp4">
						您的浏览器不支持 video 属性。
					</video>
				</div>
				<p v-else><span>播放源无效</span><span>【{{url||'无'}}】</span></p>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import indexjs from "./index.js";
	import {
		copy
	} from "clipboard";

	export default {
		methods: {
			copy,
		},
		...indexjs,
		components: {},
		computed: {},

	};
</script>

<style lang="scss" scoped>
	@import "./index.scss";
</style>